<template>
    <div class="subscription-description">
        <div class="subscription-description-headline"> {{ title }} </div>
        <div class="subscription-description-box"> <slot name="content"></slot> </div>
        <div v-if="isButtonSlot"> <slot name="button"></slot> </div>
    </div>
</template>

<script>
export default {
    name: 'SubscriptionDescriptionBox',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        isButtonSlot() {
            return !!this.$slots.button && !!this.$slots.button[0]
        }
    }
}
</script>

<style lang="scss" scoped>
.subscription-description {
    .subscription-description-headline {
        padding: 8px 12px;
        background: #fff;
        display: inline-block;
        font-size: 12px;
        margin-top: 8px;
    }
    .subscription-description-box {
        background: #fff;
        padding: 40px;
    }
    .subscription-description-button {
        background: #36ACBB;
        padding: 12px 24px;
        color: #fff;
        font-weight: bold;
        cursor: pointer;
    }
}
</style>
